module.exports = __webpack_public_path__ + "static/media/step2.1118d365.png";